import React from "react";
import { TButtonProps } from "types/Components/Common/Button";

const FillButton = ({
  type = "button",
  border = "2",
  buttonStyle = "primary",
  id = "",
  onClick,
  disabled = false,
  className,
  disabledClassName = "!tw-border-primary-disabled !tw-bg-primary-disabled",
  children,
  color,
}: TButtonProps) => {
  let _className = "!tw-border-primary !tw-bg-primary hover:!tw-bg-primary-hover hover:!tw-border-primary-hover"

  if(buttonStyle === "danger") _className = "!tw-border-danger !tw-bg-danger hover:!tw-bg-danger-hover hover:!tw-border-danger-hover"

  return (
    <div>
      <button
        type={type}
        onClick={onClick}
        disabled={disabled}
        className={` ${disabled && disabledClassName} ${_className}
        tw-border rounded  tw-box-border
        tw-cursor-pointer tw-inline-block tw-font-noto-sans tw-text-sm
        tw-leading-5 tw-min-h-[36px] tw-m-0 focus:tw-outline-none tw-p-2 tw-py-1 !tw-min-w-[92px]
        tw-relative tw-text-center tw-no-underline tw-touch-manipulation tw-select-none tw-font-normal !tw-text-white`}
      >
        {children}
      </button>
    </div>
  );
};


export default FillButton;
